const en = {
  welcome_title: "Working in the United Kingdom with a visa",
  hint_text:
    "Why do we need your personal data and how are we going to use it? " +
    "By submitting this form you agree that IBC Student Exchange is an " +
    "administrator of personal data and as such will process it in accordance with GDPR " +
    "- EU General Data Protection Regulation 2016/679. " +
    "The collection of your personal data is necessary in connection with your application " +
    "for our programmes. Please read more about our Privacy Policy:",
  privacy_policy: "I agree to the Terms and Conditions of the Privacy Policy.",
  register_google_required_title: "Google sign-in required",
  register_google_required_text:
    "To proceed, please sign in with your Google account so we can verify your email address.",
  button_google_sign_in: "Sign in with Google",
  button_google_switch_account: "Switch account",
  register_google_verified: "Using Google verified email: {email}",
  register_google_error_popup_blocked:
    "The sign-in popup was blocked by your browser. Please allow popups and try again.",
  register_google_error_popup_closed:
    "Google sign-in was cancelled. Please try again.",
  register_google_error_generic: "Google sign-in failed. Please try again.",
  document_upload_choose_image: "Choose image",
  document_upload_selected_file: "Selected file: {fileName}",
  document_upload_current_file: "Current file:",
  document_open_image: "Open image",
  document_remove_image: "Remove image",
  document_passport_image_label: "Passport image",
  document_passport_image_helper:
    "Upload a clear JPEG or PNG image of your passport, up to 3 MB. If you already uploaded one earlier, it will be shown here.",
  divider_second_passport_information: "Second Passport Information",
  second_pass_id: "Second passport number",
  second_pass_expiry_date: "Second passport expiry date",
  second_pass_id_error:
    "Second passport number is required and should only contain numbers and alphabetic characters",
  second_pass_expiry_date_error:
    "Expiry date of your second passport is required and must be in the future",
  document_uk_work_visa_image_label: "Last UK work visa image",
  document_uk_work_visa_image_helper_required:
    "A UK work-related trip in the last 2 years was detected, so a JPEG or PNG image of your latest UK work visa, up to 3 MB, is required.",
  document_uk_work_visa_image_helper_existing:
    "You already have a UK work visa image on file.",
  error_passport_image_required: "Please upload an image of your passport.",
  error_uk_work_visa_image_required:
    "Please upload an image of your last UK work visa.",
  error_upload_image_file: "Please upload a JPEG or PNG image up to 3 MB.",
  error_upload_image_failed:
    "The selected image could not be uploaded. Please try again.",
  error_remove_image_failed:
    "The selected image could not be removed. Please try again.",
  error_document_open_failed: "The document could not be opened. Please try again.",
  error_document_session_unavailable:
    "Unable to authorize document actions for this questionnaire. Please refresh and try again.",
  error_document_session_start_failed:
    "Unable to start the secure document upload session. Please try again.",
  applicant_document_kind_passport_image: "Passport image",
  applicant_document_kind_uk_work_visa_image: "UK work visa image",
  applicant_document_kind_candidate_photo: "Candidate photo",
  applicant_document_kind_payment_receipt: "Payment receipt",
  applicant_document_kind_other: "Other document",
  applicant_document_label_uploadedDocuments: "Uploaded documents",
  applicant_document_label_kind: "Document type",
  applicant_document_label_source: "Document source",
  applicant_document_label_url: "Document URL",
  applicant_document_label_storagePath: "Storage path",
  applicant_document_label_fileName: "File name",
  applicant_document_label_contentType: "Content type",
  applicant_document_label_extension: "File extension",
  applicant_document_label_uploadedAt: "Uploaded at",
  applicant_document_label_candidateId: "Candidate ID",
  applicant_document_source_questionnaire: "Questionnaire",
  applicant_document_source_recruiting: "Recruiting",
  common_open: "Open",
  security_code_lookup_title: "Latest security code",
  security_code_lookup_description:
    "Sign in with Google to check whether you have a recent security code.",
  security_code_lookup_email_label: "Email address",
  security_code_lookup_submit: "Show latest code",
  security_code_lookup_result_title: "Result",
  security_code_lookup_refresh: "Refresh",
  security_code_lookup_found_message: "A recent security code was found.",
  security_code_lookup_unrecognized: "This email address was not recognized.",
  security_code_lookup_no_recent_code:
    "No recent security code was found for this email address.",
  security_code_lookup_code_label: "Security code",
  security_code_lookup_created_at: "Received: {time}",
  security_code_lookup_not_found_detail:
    "If a new code arrives, use Refresh to check again.",
  security_code_lookup_invalid_email: "Please enter a valid email address.",
  security_code_lookup_load_error:
    "The security code could not be loaded. Please try again.",
  step_0: "Welcome",
  step_1: "General",
  step_2: "Family",
  step_3: "Travels",
  step_4: "Previous applications",
  step_5: "Miscellaneous",
  step_6: "Finish",
  divider_previous_visa_leave_to_remain: "Leave to remain in the UK",
  divider_immigration_problems: "Immigration problems",
  common_month: "Month",
  common_year: "Year",
  has_applied_for_leave_to_remain: "Have you ever applied for leave to remain in the UK?",
  has_applied_for_leave_to_remain_explanation:
    "Leave to remain is an application made whilst in the UK asking permission to stay in the UK.",
  has_immigration_problems: "Have you had any immigration problems?",
  previous_leave_application_date: "Date of application",
  previous_leave_application_result: "What was the result of your application?",
  previous_leave_application_result_approved: "Approved",
  previous_leave_application_result_refused: "Refused",
  previous_leave_application_refusal_reason: "Reason for refusal",
  button_add_previous_leave_application: "Add additional case",
  button_delete_previous_leave_application: "Delete application",
  immigration_problem_type: "Details of immigration problems",
  immigration_problem_country: "Country",
  immigration_problem_uk_appeal_awaiting:
    "Do you have an appeal against that decision which is yet to be heard or is awaiting judgement?",
  immigration_problem_uk_appeal_awaiting_error:
    "Please, select if you have an appeal against that decision that is not yet decided.",
  immigration_problem_date: "When did the immigration problem occur?",
  immigration_problem_details: "More details of what happened",
  immigration_problem_details_character_count: "{count}/500 characters",
  button_add_immigration_problem: "Add additional case",
  button_delete_immigration_problem: "Delete problem",
  immigration_problem_option_visa_refused: "An application for a visa was refused",
  immigration_problem_option_refused_entry: "I was refused entry at the border",
  immigration_problem_option_refused_stay: "I was refused permission to stay or remain",
  immigration_problem_option_refused_asylum: "I was refused asylum",
  immigration_problem_option_deported: "I was deported",
  immigration_problem_option_removed: "I was removed",
  immigration_problem_option_required_to_leave: "I was required to leave",
  immigration_problem_option_excluded: "I was excluded or banned from entry",
  error_has_applied_for_leave_to_remain_required:
    "Please, select if you have applied for leave to remain in the UK!",
  error_previous_leave_application_required:
    "Please, add at least one leave to remain application.",
  error_previous_leave_application_date_required:
    "Please, enter the application month and year.",
  error_previous_leave_application_date_future:
    "The application month and year cannot be in the future.",
  error_previous_leave_application_result_required:
    "Please, select the result of your application.",
  error_previous_leave_application_refusal_reason_required:
    "Please, provide the reason for refusal.",
  error_previous_leave_application_refusal_reason_too_long:
    "The refusal reason must be 500 characters or fewer.",
  error_previous_leave_application_refusal_reason_latin_only:
    "Please, use only latin letters for the refusal reason.",
  error_has_immigration_problems_required:
    "Please, select if you have had any immigration problems.",
  error_immigration_problem_required: "Please, add at least one immigration problem.",
  error_immigration_problem_type_required:
    "Please, select the immigration problem type.",
  error_immigration_problem_country_required: "Please, select the country.",
  error_immigration_problem_date_required:
    "Please, enter when the immigration problem occurred.",
  error_immigration_problem_date_future:
    "The immigration problem date cannot be in the future.",
  error_immigration_problem_details_required:
    "Please, provide more details of what happened.",
  error_immigration_problem_details_too_long:
    "The details must be 500 characters or fewer.",
  error_immigration_problem_uk_appeal_awaiting_required:
    "Please, select if you have an appeal against that decision that is not yet decided.",

  currentLocation: "Where are you currently located?",
  currentLocation_error: "Please select your current location",
  canAttendInterview:
    "Will you be able to attend a presentation and an interview if you are invited within the next 3 months?",
  canAttendInterview_error: "Please answer this question",
};

export default en;
